/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useEffect, useState } from 'react';
import { atualizarLayout, layoutGuardado } from '../../Api/layout';
import { useStartupState } from '../StartupState';

const HeaderStatesContext = createContext();

export const HeaderStates = ({ children }) => {
  const [title, setTitle] = useState('');
  const [bgHeader, setBgHeader] = useState(null);
  const [logoHeader, setLogoHeader] = useState(null);

  // O menu já nasce preenchido (ver Api/layout.js) e se atualiza quando o
  // Squidex responde. Não mexe no "carregando" das páginas: antes, o menu
  // chegando desligava o carregamento da página que ainda buscava os dados.
  const [menu, setMenu] = useState(() => layoutGuardado('menu') || []);

  const { token } = useStartupState();

  useEffect(() => {
    if (!token) return;
    atualizarLayout(token, 'menu')
      .then(setMenu)
      .catch((e) => console.log('menu:', e.message));
  }, [token]);

  return (
    <HeaderStatesContext.Provider
      value={{
        title,
        setTitle,
        bgHeader,
        setBgHeader,
        logoHeader,
        setLogoHeader,
        menu,
        setMenu,
      }}
    >
      {children}
    </HeaderStatesContext.Provider>
  );
};

export const useHeaderStates = () => useContext(HeaderStatesContext);
